import { Reference } from '@/types/general';
import Box from '@mui/material/Box';
import Image from 'next/image';
import { useMemo } from 'react';

export default function ImagePortable({
  value,
}: {
  value: {
    asset: Reference;
  };
}) {
  const aspectRatio = useMemo(() => {
    const ref = value?.asset?._ref;
    if (!ref) return 1; // Default aspect ratio
    const [width, height] = ref.split('-')[2].split('x');
    return Number(width) / Number(height);
  }, [value?.asset?._ref]);

  return (
    <Box
      sx={{
        width: '100%',
        aspectRatio: aspectRatio,
        position: 'relative',
        overflow: 'hidden',
        borderRadius: 0,
        my: 3,
        '& > img': {
          objectFit: 'cover',
          objectPosition: 'center',
        },
      }}
    >
      <Image
        src={value?.asset?._ref}
        alt='orthosolid'
        fill
        sizes='(max-width: 1280px) 100vw, 1280px'
        quality={80}
      />
    </Box>
  );
}
